import { types } from 'mobx-state-tree';

export const SuggestionSettingsModel = types.model('SuggestionSettingsModel', {
  id: types.identifierNumber,
  languages: types.frozen(),
  sponsor_visa: types.string,
  consider_skills: types.boolean,
  external_recruiter: types.boolean,
  preferences_url: types.string,
  main_theme: types.frozen(),
  sub_themes: types.array(types.frozen()),
  focuses: types.array(types.frozen())
});
